import { checkIfFolderExists } from '@hashnode/file-parsing'
import path from 'path'
import { ParsedConfigWithVersions } from '../../schemas'
import { generateGuidesFolderPath, getAllGuideConfigs } from '../path-helpers'
import { parseGuideConfig, parseVersionConfig } from './parse-guide-config'
import {
	replaceLocalRelativeImageLinksWithAbsolutePaths,
	replaceLocalRelativePageLinksWithAbsolutePaths,
} from './parse-page'

export function parseFolderStructure({ rootDir }: { rootDir: string }): ParsedConfigWithVersions[] {
	// 2. Check each folder under guides to see if it contains a config.ts file
	const guidesPath = generateGuidesFolderPath(rootDir)

	// Check if guides directory exists
	if (!checkIfFolderExists(guidesPath)) {
		throw new Error('Missing guides directory in the root directory.')
	}

	// Read all subdirectories in guides
	const guideFolders = getAllGuideConfigs(guidesPath)

	const guideFolderPaths = guideFolders.map((guideFolder) => path.join(guidesPath, guideFolder))

	const parsedGuideConfigsWithFolderPath = guideFolderPaths.map((guideFolderPath) => {
		const config = parseGuideConfig(guideFolderPath)
		return {
			guideFolderPath,
			config,
		}
	})

	const guideWithVersionInformation = parsedGuideConfigsWithFolderPath.map(
		({ config, guideFolderPath }) => {
			const guideWithVersionInformation = parseVersionConfig({
				guideConfig: config,
				guideFolderPath,
			})

			return {
				guideFolderPath,
				guideWithVersionInformation,
			}
		},
	)

	return guideWithVersionInformation.map(({ guideWithVersionInformation }) => {
		return guideWithVersionInformation
	})
}
// Main function to validate the folder structure
export function parseProjectStructure({ rootDir }: { rootDir: string }) {
	const guideConfigsWithVersion = parseFolderStructure({ rootDir })

	const guides = guideConfigsWithVersion.filter((guide) => guide.variant === 'GUIDE')
	const apiReferences = guideConfigsWithVersion.filter((guide) => guide.variant === 'API_REFERENCE')

	const updatedGuides = replaceLocalRelativePageLinksWithAbsolutePaths({
		configs: guides,
	})

	const { configs: updatedGuidesWithAbsolutePaths, imageAssets } =
		replaceLocalRelativeImageLinksWithAbsolutePaths({
			configs: updatedGuides,
		})

	return {
		configs: [...updatedGuidesWithAbsolutePaths, ...apiReferences],
		imageAssets,
	}
}
